import { FAREFORECASTER } from "src/common/constants";
import { FareForecasterAction } from "../reducers/fareForecaster";
import { FareForecasterFormDataI } from "src/types/FareForecaster";
export const FAREFORECASTER_UPDATE_FORM =
  `${FAREFORECASTER}_UPDATE_FORM` as const;

export const updateFareForecasterForm = (
  data: FareForecasterFormDataI,
  id: string
): FareForecasterAction => ({
  type: FAREFORECASTER_UPDATE_FORM,
  payload: data,
  id,
});
